import { z } from "zod";

import { zFieldMeta, zFilterValue, zFilterValueType } from "./ZFilterApiTypes";

// Логический оператор
export const zLogicalOperator = z.enum(["AND", "OR"]);
export type ZLogicalOperator = z.infer<typeof zLogicalOperator>;

// Узел-критерий
export const zCriterionNode = z.object({
  type: z.literal("criterion"),
  id: z.string(),
  fieldMeta: zFieldMeta.nullable(),
  valueType: zFilterValueType.nullable(),
  operator: z.string().nullable(),
  value: zFilterValue,
});
export type ZCriterionNode = z.infer<typeof zCriterionNode>;

// Узел-группа (рекурсивная)
export type ZGroupNode = {
  type: "group";
  id: string;
  op: ZLogicalOperator;
  items: ZQueryBuilderNode[];
};

export type ZQueryBuilderNode = ZCriterionNode | ZGroupNode;

export const zQueryBuilderNode: z.ZodType<ZQueryBuilderNode> = z.lazy(() =>
  z.union([zGroupNode, zCriterionNode]),
);

export const zGroupNode: z.ZodType<ZGroupNode> = z.lazy(() =>
  z.object({
    type: z.literal("group"),
    id: z.string(),
    op: zLogicalOperator,
    items: z.array(zQueryBuilderNode),
  }),
);

// Путь к узлу
export const zNodePath = z.array(z.number());
export type ZNodePath = z.infer<typeof zNodePath>;

// Type guards
export const isGroupNode = (node: ZQueryBuilderNode): node is ZGroupNode =>
  node.type === "group";

export const isCriterionNode = (
  node: ZQueryBuilderNode,
): node is ZCriterionNode => node.type === "criterion";
